import { OrderStatus, PlaceType } from '@/graphql/generated';

export const BOOK_STATUSES = {
  [OrderStatus.Avoided]: 'Аннулирован',
  [OrderStatus.Confirmed]: 'Подтвержден',
  [OrderStatus.NotConfirmed]: 'Требует подтверждения',
};

export const BOOK_STATUSES_COLORS = {
  [OrderStatus.Avoided]: 'text-red',
  [OrderStatus.Confirmed]: 'text-green',
  [OrderStatus.NotConfirmed]: 'text-primary',
};

export const PLACE_TYPES = {
  [PlaceType.Additional]: 'Дополнительное',
  [PlaceType.Base]: 'Основное',
  [PlaceType.NoPlace]: 'Без места',
};

export type BooksFilters = {
  residenceDate: Date[];
  bookDate: Date[];
  account: number | null;
  tariff: string | null;
  roomCategory: string | null;
  status: OrderStatus | null;
  checkRequired: boolean;
};

export const defaultFilters = (account?: number | undefined): BooksFilters => ({
  residenceDate: [new Date()],
  bookDate: [],

  account: account || null,
  tariff: null,
  roomCategory: null,
  status: null,

  checkRequired: false,
});
